import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Text, Box, Flex, Button, VectorRightIcon } from 'uikit'
import { useTranslation } from 'contexts/Localization'

const Model = styled.img`
  width: 280px;

  ${({ theme }) => theme.mediaQueries.md} {
    width: 350px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    width: 550px;
  }
`

const PurpleTitle = styled(Text)`
  font-size: 20px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 25px;
  }
`

const Title = styled(Text)`
  font-size: 20px;

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 28px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 30px;
  }
`

const Detail = styled(Text)`
  font-size: 14px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 16px;
  }
`

const Quality: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Flex
      mt={['95px', null, null, null, '110px']}
      justifyContent="space-between"
      mx="auto"
      alignItems="center"
      maxWidth="1240px"
      flexDirection={['column', null, null, null, null, 'row']}
    >
      <Model src="/images/home/launchpad-model.png" alt="launchpad-model" />
      <Box maxWidth={['100%', null, null, null, null, '500px']}>
        <PurpleTitle color="primary" fontWeight="600">
          {t('Launchpad')}
        </PurpleTitle>
        <Title fontWeight="600">{t('Deploy NFT Contracts and Manage in the User Panel')}</Title>
        <Detail mt={['10px', null, '15px', null, '18px']} fontWeight="300" color="textSecondary">
          {t(
            'Dark Matter DeFi Factory NFT contract provides Artists with a tool for deploying and managing NFT contracts. Artists retain complete ownership and control of their NFT contracts.',
          )}
        </Detail>
        <Button
          as={Link}
          to="/nft/launchpad"
          height="27px"
          mt={['30px', null, '40px', null, '60px']}
          variant="text"
          p="0"
          endIcon={<VectorRightIcon fill="#128DFF" />}
        >
          <Text fontSize="18px" fontWeight="500" color="#128DFF">
            {t('Deploy NFT Contract Now')}
          </Text>
        </Button>
      </Box>
    </Flex>
  )
}

export default Quality
